import { useEffect, useState } from "react";
import getUserLocation, { getInitialCountry } from "../util/getUserLocation";

const useGeoCountry = () => {
  const [country, setCountry] = useState(getInitialCountry);

  useEffect(() => {
    let isMounted = true;

    getUserLocation().then(({ countryCode }) => {
      if (isMounted && countryCode) {
        setCountry(countryCode);
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  return country;
};

export default useGeoCountry;
